module.exports = __webpack_public_path__ + "static/media/Mehr_Eghtesad.2dc125bf.svg";